<template>
	<div class="panel" v-bind:class="typeClass">
		<div class="panel-heading">
			{{ note.noteType.name }} - {{ note.created_at }}
			<button class="btn btn-default btn-xs glyphicon glyphicon-trash pull-right" v-on:click="destroy()"></button>
		</div>
		<div class="panel-body">

				<div v-if="!editMode">
					<p>{{ note.content }}</p>
					<p><em>Created by {{ note.user.first_name }} {{ note.user.last_name }} at {{ note.created_at }}</em></p>
					<div class="contents-pull-left">
						<button type="button" 
							class="btn btn-default btn-xs" 
							@click="toggleMode()" 
							title="Edit this channel">edit</button>
					</div>						
				</div>
					
				<div v-else>
					<div class="form-group">
						<textarea v-model="tempNote.content" class="form-control"></textarea>
					</div>
					<div class="form-group">
						<select v-model="tempNote.note_type_id" class="form-control">
							<option v-for="type in [{id: 1, name: 'Info'}, {id: 2, name: 'Alert'}]" :value="type.id">
								{{ type.name }}
							</option>
						</select>
					</div>
					<div>
						<button type="button" class="btn btn-default btn-xs" v-on:click="cancel()">Cancel</button>
						<button type="button" class="btn btn-default btn-xs" v-on:click="save()">Save</button>
					</div>
				</div>

		</div>
	</div>
</template>

<script setup>
	import { computed, ref, onMounted } from 'vue'
	const emit = defineEmits(['input', 'changed'])
	const props = defineProps(['note'])

	let tempNote = ref({})
	let editMode = ref(false)

	const typeClass = computed(() => {
		return (props.note.note_type_id == 2) ? 'note-alert' : 'note-info';
	})

	function toggleMode() {
		editMode.value = !editMode.value
		syncNote()
	}

	function syncNote() {
		tempNote.value = JSON.parse(JSON.stringify(props.note));
	}

	function cancel() {
		syncNote()
		toggleMode()
	}

	function save() {
		axios.put('/api/notes/'+props.note.id, tempNote.value)
			.then(function (response) {
				emit('changed')
				toggleMode()
			}.bind(this))
			.catch(function (error) {
				alert('There was a problem saving your note.  You should contact the administrator.');
			});
	}

	function destroy() {
		var conf = confirm('You are about to delete a note. This cannot be undone. Are you sure you want to continue?');
		if (conf) {
			axios.delete('/api/notes/'+props.note.id)
				.then(function (response) {
					emit('changed')
				}.bind(this))
				.catch(function (error) {
					console.log(error);
					alert('failed to delete note.')
				})
		}
	}

	onMounted(() => {
		syncNote()
	})
</script>